export default __webpack_public_path__ + "static/media/white-overlay.2866a4db.png";